module.exports = __webpack_public_path__ + "img/bar.5d5986f0.svg";